import { render, staticRenderFns } from "./DiscussionList.vue?vue&type=template&id=f662725e&"
import script from "./DiscussionList.vue?vue&type=script&lang=js&"
export * from "./DiscussionList.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports